import { Text, Card } from "components/common"
import React, { useCallback, useMemo, memo } from "react"
import { LocationMap } from "components/svg"
import styles from "./index.module.less"

const getMapURL = (mapContent) => {
  const { latitude, longitude } = mapContent
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
}

function Location({ parsedContent }) {
  const locationData = useMemo(() => ({
    latitude: parsedContent?.latitude || 0,
    longitude: parsedContent?.longitude || 0,
    caption: parsedContent?.caption || ""
  }), [parsedContent])

  const handleMapClick = useCallback(() => {
    if (locationData.latitude && locationData.longitude) {
      const mapURL = getMapURL(locationData)
      window.open(mapURL, "_blank", "noopener,noreferrer")
    }
  }, [locationData])

  return (
    <Card className={styles.mediaCard}>
      <div 
        className={styles.locationContainer}
        onClick={handleMapClick}
      >
        <LocationMap 
          className={styles.locationMap}
          aria-hidden="true"
        />
      </div>
      
      {locationData.caption && (
        <Text type="secondary" className={styles.caption}>
          {locationData.caption}
        </Text>
      )}
    </Card>
  )
}

const MemoizedLocation = memo(Location)
MemoizedLocation.displayName = 'Location'

export default MemoizedLocation
